import { useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

type Result = ModelHookResult<{
	states: ReadonlyArray<{
		name: string;
		value: unknown;
	}>;
}>;

export function usePageState(): Result {
	const {
		data: { petition },
	} = usePsfSharePageData();
	const guest = useQueryParamValue('guest');

	return {
		data: {
			states: useMemo(() => {
				return [
					{
						name: 'petition',
						value: {
							id: petition.id,
							user: { id: petition.user.id },
							createdAt: petition.createdAt,
							geoReach: petition.geoReach,
							relevantLocationLocalizedName: petition.relevantLocationLocalizedName,
							signatureCount: {
								total: petition.signatureState.signatureCount.total,
								displayed: petition.signatureState.signatureCount.displayed,
								goal: petition.signatureState.signatureGoal.displayed,
							},
							weeklySignatureCount: petition.weeklySignatureCount,
						},
					},
					{
						name: 'petitionStats',
						value: {
							viewCount: petition.viewCount,
							shareCount: petition.sharesConnection.estimatedTotalCount,
						},
					},
					{ name: 'guestUserState', value: guest },
				];
			}, [petition, guest]),
		},
	};
}
